// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.indicator-class[data-v-c0276c18] {
  width: 500px;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/views/BigDataSoftware/IndicatorClass/index.vue","webpack://./index.vue"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,YAAA;ACAF","sourcesContent":["\n.indicator-class {\n  width: 500px;\n  height: 100%;\n}\n",".indicator-class {\n  width: 500px;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
